import React from 'react';
import NumberBoxes from "../common/NumberBoxes/NumberBoxes";
import {connect} from "react-redux";

import {getMonthDutch} from "../common/Functions";

function Achievements(props) {

    return (
        <div className={'block'}>
            <NumberBoxes
                label1={'Toppy top order ' + getMonthDutch()}
                value1={Math.round(props.toppyBestOrderLast30Days)}
                isMoney1={true}
                label2={'Heuts top order ' + getMonthDutch()}
                value2={Math.round(props.heutsBestOrderLast30Days)}
            />
        </div>
    );
}


const mapStateToProps = (state = {}) => {
    const result = {
        latestNewProductSales: [],
        toppyBestOrderLast30Days: 0,
        heutsBestOrderLast30Days: 0
    };
    if (
        typeof state.data !== "undefined" &&
        typeof state.data["event-toppy-current-stats"] !== "undefined"
    ) {
        let currentStats = {};

        state.data["event-toppy-current-stats"].forEach(function (
            current_stat_response
        ) {
            currentStats[current_stat_response.label] = current_stat_response.result;
        });

        result.toppyBestOrderLast30Days = currentStats.bestOrderLast30Days;
    }

    if (
        typeof state.data !== "undefined" &&
        typeof state.data["event-heuts-current-stats"] !== "undefined"
    ) {
        let currentStats = {};

        state.data["event-heuts-current-stats"].forEach(function (
            current_stat_response
        ) {
            currentStats[current_stat_response.label] = current_stat_response.result;
        });

        result.heutsBestOrderLast30Days = currentStats.bestOrderLast30Days;
    }

    if (
        typeof state.data !== "undefined" &&
        typeof state.data["event-latest-new-product-sales"] !== "undefined"
    ) {

        result.latestNewProductSales = state.data["event-latest-new-product-sales"];
    }

    return result;
};
export default connect(mapStateToProps)(Achievements);
